module.exports = __webpack_public_path__ + "img/diqiu.dae9ce2b.gif";